import { render, staticRenderFns } from "./ResetSuccess.vue?vue&type=template&id=c9a4c916&scoped=true&"
import script from "./ResetSuccess.vue?vue&type=script&lang=js&"
export * from "./ResetSuccess.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/frontend/home.scss?vue&type=style&index=0&id=c9a4c916&lang=scss&scoped=true&"
import style1 from "@/assets/scss/frontend/content.scss?vue&type=style&index=1&id=c9a4c916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a4c916",
  null
  
)

export default component.exports